import { createFileRoute, Link } from '@tanstack/react-router';
import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthFrame } from '@/components/AuthFrame';
import { authClient } from '@/lib/auth-client';

export const Route = createFileRoute('/forgot-password')({ component: ForgotPassword });

function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    // Same answer whether or not the address exists: no account enumeration.
    await authClient.requestPasswordReset({ email, redirectTo: `${window.location.origin}/reset-password` }).catch(() => null);
    setSent(true);
  };
  return (
    <AuthFrame title={t('auth.forgotTitle')} lead={t('auth.forgotLead')}>
      {sent ? (
        <p className="text-sm">{t('auth.linkSent')}</p>
      ) : (
        <form onSubmit={submit} className="space-y-3">
          <input className="input w-full" type="email" aria-label={t('auth.email')} value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          <button type="submit" className="btn btn-primary w-full">
            {t('auth.sendLink')}
          </button>
        </form>
      )}
      <Link to="/login" className="link mt-4 block text-sm">
        {t('auth.toSignIn')}
      </Link>
    </AuthFrame>
  );
}
